// @ts-nocheck
import { AppEnvironment, environment as common } from '@env/environment.common';

export const environment: AppEnvironment = {
  production: true,
  name: 'dev',
  values: {
    ...common.values,
    dwspayPublishKey: 'pk_test_51SXP0hLEjrO5JiWJchGFqzqV2IyosENiEgF3CHeboxjiPtxAGVFIXpYNndsmkOeT90oNexGTgdNu0jWqUEsL1V5O00bgPx2mQi'
  },
  hosts: {
    wsb2c: {
      host: 'api-dev.b2c.wine-suite.com',
      protocol: 'https',
      port: '',
      root: '/api/public/',
      endpoints: {}
    }
  }
};
